import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('createBoundaryForm');

    return {
        CREATE: t('create'),
        NEXT_DRAW_THE_PERIMETER: t('nextDrawThePerimeter')
    };
};

export default useTranslation;
